"use strict";

import Vue from "vue";
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.common['Nosdk-Sign'] = 'cc2827f4c484414e185c88f51df71267ee32832b5b41224ef33f3459d49fb227';
// axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded;';

let config = {
  // baseURL: process.env.NODE_ENV === 'production' ? 'https://omnisdk.office.mattel163.com' : '/count',
  // baseURL: process.env.NODE_ENV === 'production' ? 'https://omnisdk.office.mattel163.com' : '/count',
  baseURL: process.env.VUE_APP_BASE_API,
};
const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    if (localStorage.getItem("privacy_sid")) {
      config.headers["sid"] = localStorage.getItem("privacy_sid");
    }
    console.log(config)
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

// 请求拦截
// axios.interceptors.request.use((config) => {
//   // 这里获取登录成功种植的token赋予axios
//   const userData= Getitem('userData')
//   if (userData && userData !== '{}') {
//     config.headers.Authorization = `Bearer ${JSON.parse(userData).token}`
//   } else {
//     Removeitem('userData')
//   }
//   return config
// })

Vue.use(Plugin);
export default Plugin;
